import { AgentsRegionPageNoAgentsProps } from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageNoAgents/AgentsRegionPageNoAgents.types';

export default function AgentsRegionPageNoAgents({
  locationName,
}: AgentsRegionPageNoAgentsProps) {
  return (
    <div
      className='text-center'
      data-tp-id='gen-div-41aa1bc6-02f4-473c-b888-0e65b10d9f36'
    >{`It looks like we do not have any agents listed in ${locationName}. We are currently adding new partners everyday who might not be listed yet. Fill out the form below and we will help you find your local partner agent.`}</div>
  );
}
